import {
  type AdminOrderInquiryRow,
  ORDER_INQUIRY_KIND_LABELS,
  ORDER_INQUIRY_RESOLUTION_LABELS,
  ORDER_INQUIRY_STATUS_LABELS,
} from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { formatDateTime } from '@/shared/lib';
import { cn, StatusBadge, tableStyles } from '@/shared/ui';

interface OrderInquiryListRowProps {
  readonly inquiry: AdminOrderInquiryRow;
}

/** 문의 목록의 한 행 — 주문 번호를 누르면 상세(/order-inquiries/:id)로 간다. */
export const OrderInquiryListRow = ({ inquiry }: OrderInquiryListRowProps): ReactElement => (
  <tr className={tableStyles.row}>
    <td className={cn(tableStyles.td, 'whitespace-nowrap')}>
      <Link
        to={`/order-inquiries/${inquiry.id}`}
        className="underline decoration-foreground/30 underline-offset-4 hover:decoration-foreground focus-visible:outline-none"
      >
        {inquiry.orderNumber}
      </Link>
    </td>
    <td className={cn(tableStyles.td, 'whitespace-nowrap')}>{inquiry.contactName}</td>
    <td className={cn(tableStyles.td, 'whitespace-nowrap')}>
      {ORDER_INQUIRY_KIND_LABELS[inquiry.kind]}
    </td>
    <td className={tableStyles.td}>
      <StatusBadge tone={inquiry.status === 'OPEN' ? 'warning' : 'positive'}>
        {ORDER_INQUIRY_STATUS_LABELS[inquiry.status]}
      </StatusBadge>
    </td>
    <td className={cn(tableStyles.td, 'whitespace-nowrap')}>
      {inquiry.resolution ? ORDER_INQUIRY_RESOLUTION_LABELS[inquiry.resolution] : '—'}
    </td>
    <td className={cn(tableStyles.td, 'tabular-nums')}>{inquiry.imageCount}</td>
    <td className={cn(tableStyles.td, 'whitespace-nowrap')}>{formatDateTime(inquiry.createdAt)}</td>
  </tr>
);
